import { computed, type Ref } from 'vue';
import { useQuery } from '@vue/apollo-composable';
import { MY_SCHOOLS } from '@/graphql';
import type { SchoolPaginator } from '@/types/composition-functions';

/**
 * Whether the account belongs to more than one school, so "Switch school" is
 * worth offering. The login / me-query school list is staff-only; mySchools
 * also counts the schools where the user is a guardian, so it is asked (one
 * row is enough, the total says the rest) only when the known list is short.
 */
export function useHasMultipleSchools(knownSchoolCount: Ref<number>) {
  const { result } = useQuery<{ mySchools: SchoolPaginator }>(
    MY_SCHOOLS,
    { first: 1, page: 1 },
    () => ({ enabled: knownSchoolCount.value <= 1, fetchPolicy: 'cache-first' }),
  );
  return computed(() => knownSchoolCount.value > 1 || (result.value?.mySchools?.paginatorInfo?.total ?? 0) > 1);
}
